/**
 * The enum used for increase or decrease indentation of a block
 * Used by setIndentation API
 */
// eslint-disable-next-line etc/no-const-enum
export var Indentation;
(function (Indentation) {
    /**
     * Increase indentation
     */
    Indentation[Indentation["Increase"] = 0] = "Increase";
    /**
     * Decrease indentation
     */
    Indentation[Indentation["Decrease"] = 1] = "Decrease";
})(Indentation || (Indentation = {}));
//# sourceMappingURL=Indentation.js.map